import React from 'react';
import styles from './TablesAndFiguresTab.module.css';

interface TablesAndFiguresTabProps {
    tables: any[];
    infographics?: any[];
}

const formatTitle = (title: string) => {
    const colonIndex = title.indexOf(':');
    if (colonIndex !== -1) {
        const prefix = title.substring(0, colonIndex + 1);
        const rest = title.substring(colonIndex + 1);
        return (
            <>
                <strong style={{ fontWeight: 700 }}>{prefix}</strong>
                {rest}
            </>
        );
    }
    return <strong style={{ fontWeight: 700 }}>{title}</strong>;
};

const TablesAndFiguresTab: React.FC<TablesAndFiguresTabProps> = ({ tables, infographics = [] }) => {
    const hasContent = (tables && tables.length > 0) || (infographics && infographics.length > 0);

    if (!hasContent) {
        return <div className={styles.emptyState}>No tables or figures available.</div>;
    }

    return (
        <div className={styles.tabContent}>
            {tables && tables.length > 0 && (
                <>
                    <h3 className={styles.contentHeading}>List Of Tables</h3>
                    <ul className={styles.contentList}>
                        {tables.map((table, index) => {
                            const title = table.table_title || table.title || `Table ${index + 1}`;
                            return (
                                <li key={index} className={styles.listItem}>
                                    <span className={styles.itemTitle}>{formatTitle(title)}</span>
                                    {table.description && <span className={styles.itemDescription}> {table.description}</span>}
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}

            {infographics && infographics.length > 0 && (
                <>
                    <h3 className={styles.contentHeading} style={{ marginTop: '30px' }}>List Of Figures</h3>
                    <ul className={styles.contentList}>
                        {infographics.map((info, index) => {
                            const title = info.title || `Figure ${index + 1}`;
                            return (
                                <li key={index} className={styles.listItem}>
                                    <span className={styles.itemTitle}>{formatTitle(title)}</span>
                                    {info.description && <span className={styles.itemDescription}> {info.description}</span>}
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}
        </div>
    );
};

export default TablesAndFiguresTab;
